import gsap from 'gsap'
import { BB } from '@utils/utils'
import Draggable from '../../vendors/gsap/Draggable.min'
import InertiaPlugin from '../../vendors/gsap/InertiaPlugin.min'
import BaseComponent from './_BaseComponent'



/* RIBBON
---------------------------------------------------------------------------------------------------- */

export default class Ribbon extends BaseComponent {

    constructor($el, namespace) {
        super('Ribbon', $el, namespace)


        this.startObserver()
        this.on()
    }


    bindProperties() {
        this.isIntersecting = false

        this.proxy          = document.createElement('div')
        this.dir            = this.$el[0].hasAttribute('data-ribbon-reversed') ? -1 : 1
        this.scrollPosition = { value: 0 }
        this.prevScrollPos  = 0
        this.scrollVelocity = 0

        this.draggableArea = this.$el[0].closest('.js-Ribbon-draggable') || this.$el[0]

        this.getSize()
        this.buildTL()
    }



    bindHandlers() {
        this.resizeHandler = () => this.onResize()
        this.scrollHandler = () => this.onScroll()
    }



    bindEvents() {
        const { $win, $doc } = this.$utils

        this.addListeners(
            [$doc, 'layoutChange', this.resizeHandler],
            [$win, 'scroll', this.scrollHandler],
        )
    }



    /* Handlers
    --------------------------------------------------------- */

    onResize() {
        this.getSize()
        this.buildTL()
    }

    onScroll() {
        gsap.to(this.scrollPosition, {
            value: window.scrollY,
            ease: 'power2.out',
            duration: 0.6,

            onUpdate: () => {
                this.scrollVelocity = this.scrollPosition.value - this.prevScrollPos
                this.prevScrollPos = this.scrollPosition.value
            },
        })


        const pr = this.animation.progress()
        const vel = this.scrollVelocity * -0.0001
        const isForward = vel >= 0

        this.animation.reversed(!isForward)
        this.animation.progress(pr + vel)
    }



    /* Actions
    --------------------------------------------------------- */

    buildTL() {
        gsap.killTweensOf([this.$refs.mover, this.proxy])

        this.animation = gsap.timeline({
            onComplete: () => {
                this.animation.progress(0.0001)
            },

            onReverseComplete: () => {
                this.animation.progress(0.9999)
            },
        })

        this.animation.fromTo(this.$refs.mover, {
            x: -this.offsetX / (2 * this.dir),
        }, {
            x: this.offsetX / (2 * this.dir),
            ease: 'linear',
            duration: 50,
            force3D: true,
        })


        this.animation.progress(Math.random())


        this.draggable = new Draggable(this.proxy, {
            type: 'x',
            trigger: this.draggableArea,
            inertia: true,

            onPressInit: () => {
                this.animation.pause()
            },

            onDrag: () => this.updateProgress(),
            onThrowUpdate: () => this.updateProgress(),

            onRelease: () => {
                if (!this.draggable.isThrowing) this.animation.resume()
            },

            onThrowComplete: () => {
                if (this.isIntersecting) this.animation.resume()
            },
        })

        this.toggleAnimation(this.isIntersecting)
    }


    updateProgress() {
        const vel = InertiaPlugin.getVelocity(this.proxy, 'x') * 0.006 + this.scrollVelocity * -0.0001
        const isForward = vel >= 0
        const direction = isForward ? 1 : -1

        const normalizeVelocity = Math.max(0.5, Math.abs(vel)) * 0.001
        const progress = gsap.utils.wrap(0, 1, this.animation.progress() + normalizeVelocity * direction)

        this.animation.reversed(!isForward)
        this.animation.progress(progress)
    }


    startObserver() {
        this.observer = new IntersectionObserver(([entry]) => {
            this.isIntersecting = entry.isIntersecting

            this.toggleAnimation(this.isIntersecting)
        })


        this.observer.observe(this.draggableArea)
    }

    toggleAnimation(shouldAnimate) {
        if (shouldAnimate) {
            this.animation.resume()
        } else {
            this.animation.pause()
        }
    }


    /* Values
    --------------------------------------------------------- */

    getSize() {
        this.offsetX = Array.from(this.$refs.txt).slice(0, 2).reduce((a, c) => a + c.offsetWidth, 0)
    }



}




/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */
